<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-level-rail" v-if="is_status">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="backClick">返回上一页</el-button>
    </div>

    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <!-- <el-form-item label="招商中心名称">
          <el-input placeholder="请输入招商中心名称" v-model="formInline.fname">

          </el-input>
        </el-form-item> -->

        <el-form-item label="父级名称/ID">
          <el-input placeholder="请输入父级名称/ID" v-model="formInline.parent">

          </el-input>
        </el-form-item>


        <el-form-item label="服务商名称">
          <el-input placeholder="请输入服务商名称" v-model="formInline.search">

          </el-input>
        </el-form-item>

        <el-form-item label="用户昵称/手机号/ID">
          <el-input placeholder="请输入用户昵称/手机号/ID" v-model="formInline.umobile">

          </el-input>
        </el-form-item>

        <el-form-item label="联系人/联系电话">
          <el-input placeholder="请输入联系人/联系电话" v-model="formInline.mobile">

          </el-input>
        </el-form-item>

        <el-form-item label="选择角色" prop="service_role_id">
        <el-select v-model="formInline.service_role_id" @change="changeRole">
          <template v-for="(item,index) in serviceRoleList">
            <el-option
              :value="item.service_role_id"
              :key="index"
              :label="item.name"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>



        <el-form-item label="状态">
          <el-select size="small" v-model="formInline.status" placeholder="请选择状态">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>

        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加服务商</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="service_id" label="ID"></el-table-column>
            <!-- <el-table-column prop="filiale.name" label="招商中心"></el-table-column> -->
            <el-table-column prop="parent.name" label="上一级"></el-table-column>
            <el-table-column prop="avatarUrl" label="服务商Logo">
            <template slot-scope="scope">
              <div v-if="scope.row.avatarUrl">
                <img :src="scope.row.avatarUrl" width="60px" height="60px"/>
              </div>
            </template>
          </el-table-column>
            <el-table-column prop="name" label="服务商名称"></el-table-column>
            <el-table-column prop="service_role" label="角色"></el-table-column>

            
            <el-table-column prop="nickname" label="联系人"></el-table-column>
            <el-table-column prop="mobile" label="联系电话"></el-table-column>
            <el-table-column prop="sales_people" label="关联用户">
              <template slot-scope="scope">
                <div v-if=" scope.row.user && scope.row.user.nickName">姓名：{{ scope.row.user.nickName }}</div>
                <div v-if=" scope.row.user && scope.row.user.mobile">联系方式：{{scope.row.user.mobile }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="address" label="地址" label-width="200px"></el-table-column>



            <el-table-column prop="time" label="状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>

              </template>
            </el-table-column>

            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">

                <el-button @click="equipClick(scope.row)" type="text" size="small">设备</el-button>
                <el-button @click="logClick(scope.row)" type="text" size="small">收入</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" :filiale_id_t="filiale_id"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :service_id="service_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    </div>
</template>

<script>
  import ServiceApi from '@/api/service.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit

    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          fname:"",
          search:"",
          sales:"",
          status:-1,
          address:"",
          parent:""
        },

        open_add:false,
        open_edit:false,
        service_id:"",
        open_package_add:false,
        is_status:false,
        filiale_id:0,
        serviceList:[],
        serviceRoleList:[]
      };
    },
    created() {
      this.formInline.fname = this.$route.query.filiale_id
      this.filiale_id =  this.$route.query.filiale_id
      console.log("this.filiale_id",this.filiale_id)
      this.is_status = false;
      if(this.$route.query.filiale_id){
        this.is_status = true;
      }
      /*获取列表*/
      this.getTableList();
      this.getServiceRole()
    },
    methods: {
        changeRole(){
          this.getTableList();
      },
      getServiceRole(){
      var self = this;
      ServiceApi.getServiceRole({
      
      }, true)
            .then(data => {
              self.serviceRoleList = data.data
    
      });
    },
      backClick(){
        this.$router.back(-1);
      },
      isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        self.loading = true;
        ServiceApi.setStatus({status:status,service_id:row.service_id}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })
    },
      reast(){
        this.formInline = {
          search:"",
          sales:"",
          status:-1,
          address:"",
          parent:"",
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closePackageFunc(){
      this.getData();
      this.open_package_add = false
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        ServiceApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==1?true:false;
            }
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      packageClick(row){
        let self = this;
        self.open_package_add = true
        self.service_id = row.service_id;
      },

      equipClick(row){
        let self = this;
        self.$router.push({
          path: '/plus/service/index',
          query: {
            type: "equip",
            equip_no:row.service_id,
            "dtype":2
          }
        });
      },
      logClick(row){
        let self = this;
        self.$router.push({
          path: '/plus/service/index',
          query: {
            type: "log",
            fs:row.name,

          }
        });
      },
      /*编辑活动*/
      editClick(row) {
        this.service_id = row.service_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ServiceApi.del(
              {
                service_id: row.service_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/service/service/index.vue